import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingSection} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useUser} from '@deezer/react-user';

export const Sacem: FunctionComponent = () => {
	const [user] = useUser();
	if (user && user?.country !== 'FR') {
		return null;
	}
	return (
		<LandingSection isContained>
			<Image
				priority
				aspectRatio="516/363"
				maxW={{base: '720px'}}
				sizes="50vw"
				src="ad55ab338b759faf544c76615a44e2df.png"
				alt="sacem"
			/>
			<LandingHeading as="h2" maxWidth="550px" textAlign="center">
				Deezer et la Sacem s&apos;associent
			</LandingHeading>
			<LandingParagraph
				maxWidth="550px"
				color="text.neutral.primary.default"
				textAlign="center"
			>
				Révolution dans l&apos;univers du streaming, Deezer et la Sacem
				s&apos;associent pour une rémunération plus équitable des droits
				d&apos;auteurs à partir de janvier 2025. C&apos;est la première mise à
				jour mondiale du modèle depuis l&apos;introduction du streaming il y a
				plus de quinze ans. Grâce à ce partenariat, l&apos;ensemble des droits
				gérés par la Sacem seront rémunérés en utilisant l&apos;ACPS en France.
			</LandingParagraph>
		</LandingSection>
	);
};
